//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";
import {featureNormalizer} from "@/utils/feature-normalizer";

export default {
  name: "SectionExcursionOnMap",
  components: {
    Section: () => import('@/components/common/Section/index'),
    OnMap: () => import('@/components/common/OnMap/index')
  },
  data() {
    return {
      pending: false,
      featuresCollection: [],
    }
  },
  computed: {
    ...mapGetters({
      city: 'cities/default',
      types: 'categories/places',
      excursion: 'excursion/excursion',
      viewportWidth: 'viewport/width'
    }),
    location() {
      return this?.city?.location || this.$config.coords
    },
    show() {
      return (this?.excursion?.direction?.length > 0 || this?.excursion?.places.length > 0) &&
        (this.$hd() || this.$lg() || this.$md()) && !this.pending
    },
  },
  watch: {
    viewportWidth() {
      this.pending = true
      setTimeout(() => {
        this.pending = false
      })
    }
  },
  mounted() {
    setTimeout(() => {
      let collection = this.excursion?.places?.map((item) => {
        return featureNormalizer(item)
      })
      if (this.excursion?.direction?.length > 0) {
        collection = [...collection, {
          type: 'Feature',
          properties: [],
          geometry: {
            type: 'LineString',
            coordinates: this.excursion?.direction
          }
        }]
      }
      this.featuresCollection = collection
    }, 1)
  }
};
